// Configuración del paso "Seguros" — preparada para reuso futuro con Placas/GPS.

export const STEP_TYPE = 'add_insurance';
export const STEP_LABEL = 'Seguros';
export const STEP_ICON = 'pi pi-shield';

export const COVERAGE_OPTIONS = [
  { value: 'Amplia',       label: 'Amplia' },
  { value: 'Amplia Plus',  label: 'Amplia Plus' },
  { value: 'Limitada',     label: 'Limitada' },
  { value: 'RC',           label: 'Responsabilidad Civil' },
];

export const CANCEL_REASONS = [
  { value: 'cliente_baja',         label: 'Cliente solicita baja' },
  { value: 'cambio_aseguradora',   label: 'Cambio de aseguradora' },
  { value: 'impago',               label: 'Impago / fraude' },
  { value: 'siniestro_total',      label: 'Siniestro total' },
  { value: 'provider_cancelled',   label: 'Aseguradora canceló' },
  { value: 'otro',                 label: 'Otro' },
];

export const REJECT_REASONS = [
  { value: 'vin_no_localizado',    label: 'VIN no localizado' },
  { value: 'documentacion_falta',  label: 'Falta documentación' },
  { value: 'precio_no_acordado',   label: 'Precio fuera de rango' },
  { value: 'no_acepta_cliente',    label: 'No acepta al cliente' },
  { value: 'otro',                 label: 'Otro' },
];

// Convierte un código de motivo (cancel o reject) en su etiqueta legible.
// Si no lo encuentra, formatea el código (snake_case → "Snake case").
export function reasonLabel(code) {
  if (!code) return '';
  const found = [...CANCEL_REASONS, ...REJECT_REASONS].find((r) => r.value === code);
  if (found) return found.label;
  return String(code).replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

// Etiquetas humanas para los event_type que vienen del backend.
export const EVENT_LABELS = {
  email_sent:                  { label: 'Correo enviado',                  icon: 'pi-send',          color: 'cyan'   },
  document_uploaded:           { label: 'Documento subido',                icon: 'pi-cloud-upload',  color: 'cyan'   },
  ai_extracted:                { label: 'IA extrajo datos',                icon: 'pi-sparkles',      color: 'orange' },
  created:                     { label: 'Paso completado',                 icon: 'pi-check-circle',  color: 'green'  },
  price_discrepancy_resolved:  { label: 'Discrepancia de precio',          icon: 'pi-exclamation-triangle', color: 'orange' },
  policy_amended:              { label: 'Póliza modificada',               icon: 'pi-pencil',        color: 'blue'   },
  corrected:                   { label: 'Corrección aplicada',             icon: 'pi-pencil',        color: 'blue'   },
  endorsement:                 { label: 'Endoso registrado',               icon: 'pi-file-edit',     color: 'blue'   },
  cancelled:                   { label: 'Seguro cancelado',                icon: 'pi-ban',           color: 'red'    },
  renewed:                     { label: 'Seguro renovado',                 icon: 'pi-refresh',       color: 'green'  },
  reopened:                    { label: 'Paso reabierto',                  icon: 'pi-replay',        color: 'blue'   },
  provider_rejected:           { label: 'Aseguradora rechazó',             icon: 'pi-times-circle',  color: 'red'    },
  note:                        { label: 'Nota',                            icon: 'pi-comment',       color: 'cyan'   },
};

export function mapInsuranceStepStatus(step, insurance) {
  // Mapea status del backend a estados de la UI
  if (!step) return 'pending';
  if (step.status === 'unsuccessful') return 'rejected';
  if (step.status === 'completed' && insurance?.status === 'cancelled') return 'cancelled';
  if (step.status === 'completed') return 'completed';
  if (step.status === 'in-progress') return 'sent';
  return 'pending';
}
